"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.List = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _oxygenConfig = require("@8x8/oxygen-config");
var _themeName = _interopRequireDefault(require("../constants/themeName"));
var _ListStyled = _interopRequireDefault(require("../styled/ListStyled"));
var _excluded = ["theme", "children", "isOrdered", "isGroup", "withBackground"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var List = function List(_ref) {
  var theme = _ref.theme,
    children = _ref.children,
    isOrdered = _ref.isOrdered,
    isGroup = _ref.isGroup,
    withBackground = _ref.withBackground,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_ListStyled["default"], _extends({
    isGroup: isGroup,
    isOrdered: isOrdered,
    withBackground: withBackground
  }, otherProps), children));
};
exports.List = List;
List.propTypes = {
  /**
   * List theme
   */
  theme: _propTypes["default"].object.isRequired,
  /**
   * Rendered item content should be `ListItem` component
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * Tell when list is styled as a group
   */
  isGroup: _propTypes["default"].bool,
  /**
   * Tell when list is ordered
   */
  isOrdered: _propTypes["default"].bool,
  /**
   * Tell when list has background
   */
  withBackground: _propTypes["default"].bool
};
List.defaultProps = {
  isOrdered: false,
  isGroup: false,
  withBackground: false
};
var _default = (0, _oxygenConfig.withTheme)(List, _themeName["default"]);
exports["default"] = _default;